'use client';
import { createStyles, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles((theme, { color, activeColor, active })=>{
    const { fn: { space, up, deriveStates, transition, typography }, palette } = theme;
    const typographyStyles = typography({
        color: active ? activeColor : color,
        align: 'center',
        size: [
            10,
            14
        ],
        weight: 'semibold'
    });
    const states = deriveStates(palette.background.highlight, 'light');
    return {
        root: _extends({}, transition(), {
            textDecoration: 'none',
            padding: space('2s 0 3s'),
            cursor: 'pointer',
            width: '100%',
            [up('sm1')]: {
                padding: space('2.5s 0')
            },
            '&:hover': {
                background: states.hover
            },
            '&:active': {
                background: states.active
            }
        }),
        inner: {
            boxSizing: 'border-box',
            display: 'flex',
            padding: space('0.5s 0'),
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 42,
            [up('sm1')]: {
                flexDirection: 'row',
                gap: space('3s')
            }
        },
        text: _extends({}, typographyStyles, {
            userSelect: 'none',
            [up('sm1')]: {
                fontSize: rem(13),
                lineHeight: rem(18)
            }
        }),
        icon: {}
    };
});

export { useStyles as default };
//# sourceMappingURL=TabNavigationItem.styles.js.map
